export const filedMatch = /[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*/g;
export const pathCkExp = /\./;
export const attrExp = /^\[\w+\]$/;
export const pipeExp = /(\s\|\s\w+(:.+)?)+$/;
